/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.admin.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type GetPlatformUsersQueryVariables = Types.Exact<{
  where: Types.Users_Bool_Exp;
  offset: Types.Scalars['Int']['input'];
  limit: Types.Scalars['Int']['input'];
  orderBy?: Types.InputMaybe<Array<Types.Users_Order_By> | Types.Users_Order_By>;
}>;

export type GetPlatformUsersQuery = {
  __typename?: 'query_root';
  usersAggregate: {
    __typename?: 'users_aggregate';
    aggregate?: { __typename?: 'users_aggregate_fields'; count: number } | null;
  };
  users: Array<{
    __typename?: 'users';
    id: string;
    email?: string | null;
    displayName: string;
    password_disabled: boolean;
    organization_users: Array<{
      __typename?: 'organization_users';
      disabled: boolean;
      organization_id: string;
    }>;
    organization_users_aggregate: {
      __typename?: 'organization_users_aggregate';
      aggregate?: { __typename?: 'organization_users_aggregate_fields'; count: number } | null;
    };
  }>;
};

export const GetPlatformUsersDocument = `
    query GetPlatformUsers($where: users_bool_exp!, $offset: Int!, $limit: Int!, $orderBy: [users_order_by!]) {
  usersAggregate(where: $where) {
    aggregate {
      count
    }
  }
  users(where: $where, offset: $offset, limit: $limit, order_by: $orderBy) {
    id
    email
    displayName
    password_disabled
    organization_users {
      disabled
      organization_id
    }
    organization_users_aggregate {
      aggregate {
        count
      }
    }
  }
}
    ` as string & TypedDocumentNode<GetPlatformUsersQuery, GetPlatformUsersQueryVariables>;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    GetPlatformUsers: build.query<GetPlatformUsersQuery, GetPlatformUsersQueryVariables>({
      query: (variables) => ({ document: GetPlatformUsersDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const { useGetPlatformUsersQuery, useLazyGetPlatformUsersQuery } = injectedRtkApi;
